import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { LegData } from '../../../src/models/vessel-performance-model';
import { PerformanceUtils } from '../../../src/utils/performance-utils';

@customElement('block-performance-chart')
export class BlockPerformanceChart extends LitElement {
    @property({type: Object}) data: LegData = PerformanceUtils.ZeroLegData();

    static get styles() {
        return [
            css`
            :host {
                display: flex;
                flex-direction: row;
                font-family: 'MaerskText';
                max-height: 75px;
            }

            .header {
                display: flex;
                flex-direction: column;
                writing-mode: vertical-rl;
                transform: rotate(180deg);
                justify-content: space-around;
                align-items: center;
                background: var(--neutrals-grey-10);
                min-width: 36px;
                padding: 5px 0;
                text-align: center;
            }

            .title {
                color: var(--neutrals-grey-03, black);
                font-size: 12px;
            }

            .graph {
                display: flex;
                flex-direction: row;
                background: var(--performance-viewer-graph-background);
                width: 315px;
                height: 75px;
            }

            .reading {
                width: 100%;
                margin: 4px;
                border-bottom: 2px solid;
                text-align: center;
            }

            .reading.actual {
                border-color: var(--performance-viewer-actual-color);
            }

            .reading.simulated {
                border-color: var(--performance-viewer-simulated-color);
            }

            .reading.nextleg {
                border-color: var(--performance-viewer-nextleg-color);
            }

            .reading.range {
                border-color: var(--performance-viewer-range-color);
            }

            .toptext {
                color: var(--performance-viewer-dial-text-color);
                font-size: 20px;
                line-height: 32px;
            }

            .lowertext {
                color: var(--performance-viewer-dial-text-color);
                font-size: 12px;
                line-height: 25px;
            }
        `];
    }

    render() {
        const showRange = this.data.simulated?.lower !== undefined && this.data.simulated?.upper !== undefined;

        return html`
            <div class="header">
              <span class="title">${this.data.title}</span>
            </div>
            <div class="graph">
                ${this.data.hasOwnProperty('current') ? this._renderBox([this.data.current || null], "actual") : html``}
                ${this._renderBox([this.data.simulated?.value || null], "simulated")}
                ${showRange ? this._renderBox([this.data.simulated!.lower!, this.data.simulated!.upper!], "range") : html``}
                ${this._renderBox([this.data.nextLeg], "nextleg")}
            </div>
        `;
    }

    _renderBox(values: (number|null)[], type: string) {
        let text = "N/A";

        if (values.length === 1 && values[0] !== null) {
            text = values[0].toFixed(1);
        }

        if (values.length === 2 && values[0] !== null && values[1] !== null) {
            text = `${values[0].toFixed(1)} - ${values[1].toFixed(1)}`
        }

        return html `
            <div class="reading ${type}">
                <div class="toptext">${text}</div>
                <div class="lowertext">${this.data.unit}</div>
            </div>
        `;
    }
};
